<template>
  <section>
    <h2 class="my1">Usar Como</h2>
    <h4 class="my1">
      Essa funcionalidade permite utilizar o curso com se fosse qualquer um dos alunos.
      Após pesquisar, clique no nome do aluno selecionado.
    </h4>
    <h4>Pesquisar Emails</h4>
    <div class="flex flex-row">
      <div class="flex-auto">
        <input
          v-model="pesquisar"
          class="input"
        />
      </div>
      <div class="flex-none">
        <span
          class="btn btn-primary"
          @click="fetch()"
        >Pesquisar</span>
      </div>
    </div>
    <div v-show="records.length > 0">
      <responsiveGrid
        :onRecordClick="usarcomo"
        :config="{}"
        :fieldDefs="fieldDefs"
        :records="records"
      >
      </responsiveGrid>
    </div>
  </section>
</template>

<script>
import responsiveGrid from 'acefy/responsiveGrid/responsiveGrid'
var componentDefinition = {
  components: { responsiveGrid },
  route: {
    name: 'usarcomo',
    path: '/aluno/:idaluno/usar-como',
    meta: {
      title: 'Usar Como'
    }
  },
  data: function () {
    return {
      pesquisar: '',
      records: [],
      fieldDefs: [
        {
          fieldName: 'ID',
          title: 'ID'
        },
        {
          fieldName: 'EMAIL',
          title: 'Email'
        },
        {
          fieldName: 'NOME',
          title: 'Nome'
        }
      ]
    }
  },
  methods: {
    fetch: function () {
      var promise = this.$requests.get([
        '/ALUNOS/ORDERBY/EMAIL/WHERE/EMAIL/LIKE',
        this.pesquisar
      ].join('/'))
      promise.then(response => {
        this.records = response.data.records || []
      })
    },
    usarcomo: function (record) {
      this.$router.push(['/aluno/', record.ID].join(''))
    }
  }
}
export default componentDefinition
</script>
